module.exports = __webpack_public_path__ + "fonts/CCDashDecentW00-Heavy.49d6ed05.woff";